import { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import styles from './styles/CheckoutFriendRedemption.scss';
import * as tracking from 'dibs-tracking';

export const CheckoutFriendRedemption = ({ onClick }) => {
    const onLinkClick = useCallback(() => {
        tracking.trackEvent({
            label: 'checkout',
            action: 'referred by friend click',
            category: 'friend referral',
        });
        if (onClick) {
            onClick();
        }
    }, [onClick]);

    useEffect(() => {
        tracking.trackEvent({
            action: 'launch mme referee link',
            category: 'mme referee link',
            label: 'mme referee link',
        });
    }, []);

    return <div onClick={onLinkClick} id="mmWrapper" className={styles.checkoutFriendRedemption} />;
};

CheckoutFriendRedemption.propTypes = {
    onClick: PropTypes.func,
};
